import React, { ChangeEventHandler, ReactElement } from 'react';

import './text-input.scss';

type Props = {
  label?: string;
  name: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  type?: 'text' | 'password';
  autoFocus?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

const TextInput = ({ label, name, value, onChange, type, autoFocus, disabled, onClick }: Props): ReactElement => {
  return (
    <div className="text-input">
      {label && (
        <div className="text-input__label-container">
          <label htmlFor={name}>{label}</label>
        </div>
      )}
      <input
        className="text-input__input"
        id={name}
        value={value}
        onChange={onChange}
        type={type}
        autoFocus={autoFocus}
        disabled={disabled}
        onClick={onClick}
        autoComplete="off"
      />
    </div>
  );
};

export default TextInput;
